import { render, staticRenderFns } from "./Button3d.vue?vue&type=template&id=3bde4e91&scoped=true&lang=pug"
import script from "./Button3d.vue?vue&type=script&lang=js"
export * from "./Button3d.vue?vue&type=script&lang=js"
import style0 from "./Button3d.vue?vue&type=style&index=0&id=3bde4e91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde4e91",
  null
  
)

export default component.exports